"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
__exportStar(require("./src/calculate-average"), exports);
__exportStar(require("./src/calculate-total-sum"), exports);
__exportStar(require("./src/camel-to-capitalize"), exports);
__exportStar(require("./src/capitalize"), exports);
__exportStar(require("./src/convert-date"), exports);
__exportStar(require("./src/convert-date-short"), exports);
__exportStar(require("./src/convert-price"), exports);
__exportStar(require("./src/convert-to-email"), exports);
__exportStar(require("./src/convert-to-pascal"), exports);
__exportStar(require("./src/convert-youtube"), exports);
__exportStar(require("./src/delete-duplicates"), exports);
__exportStar(require("./src/detect-language"), exports);
__exportStar(require("./src/format-hours"), exports);
__exportStar(require("./src/generate-numbers"), exports);
__exportStar(require("./src/get-first-name"), exports);
__exportStar(require("./src/get-last-name"), exports);
__exportStar(require("./src/get-percentage"), exports);
__exportStar(require("./src/get-random"), exports);
__exportStar(require("./src/get-random-avatar"), exports);
__exportStar(require("./src/get-random-date"), exports);
__exportStar(require("./src/get-random-number"), exports);
__exportStar(require("./src/get-random-string"), exports);
__exportStar(require("./src/get-random-time"), exports);
__exportStar(require("./src/get-time-now"), exports);
__exportStar(require("./src/get-today"), exports);
__exportStar(require("./src/get-tomorrow"), exports);
__exportStar(require("./src/regex"), exports);
__exportStar(require("./src/scroll-to-top"), exports);
__exportStar(require("./src/slugify"), exports);
__exportStar(require("./src/stringifyPx"), exports);
__exportStar(require("./src/unslugify"), exports);
__exportStar(require("./src/uuid"), exports);
__exportStar(require("./src/disable-scroll"), exports);
__exportStar(require("./src/enable-scroll"), exports);
__exportStar(require("./src/sort-by-frequency"), exports);
